import axios from "axios";
import { getLocale, getToken, removeToken, removeUser } from "../utils";

// Set up default config for http requests here
const axiosService = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

axiosService.interceptors.request.use(async (config) => {
	const accessToken = getToken();
	const locale = getLocale()
	console.log("🚀 ~ locale:", locale)
	if (accessToken) {
		config.headers["Authorization"] = `${accessToken}`;
	}

	if (locale) {
		config.headers['accept-language'] = locale
	}

	return config;
})

axiosService.interceptors.response.use(
	(response) => {
		if (response && response.data) {
			return response.data;
		}
		return response;
	},
	(error) => {
		switch (error.response.status) {
			case 401:
				removeHeader("Authorization");
				removeUser()
				window.location.href = "/login";

				break;
			case 500:
				if (error.response.data.message === 'jwt expired') {
					removeHeader("Authorization");
					removeUser()
					window.location.href = "/login";
				}
				break;
			default:
				return Promise.reject(error);
		}
		return Promise.reject(error);
	}
);

const setHeader = (name, value) => {
	axiosService.defaults.headers.common[name] = value;
};

const removeHeader = (name) => {
	delete axiosService.defaults.headers.common[name];
};

export { axiosService, setHeader, removeHeader };
